import React from 'react';

// Components
import Icon from '../Icon';

// Store
import { useSelector } from 'react-redux';

// Utils
import { useMediaQuery } from 'react-responsive';
import _find from 'lodash/find';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

const Buttons = ({
  isLoading,
  addToCart,
  item,
  history,
  isDisabled,
  selectedProduct,
}) => {
  const { items } = useSelector(state => state.cart);
  const isMob = useMediaQuery({ query: '(max-width: 909px)' });
  const { t } = useTranslation();

  if (isLoading) {
    return null;
  }

  const handleAddAndOrder = item => {
    let found = _find(items, { id: selectedProduct.id });

    if (!found) {
      addToCart(item);
      history.push('/order');
    } else {
      history.push('/order');
    }
  };

  return (
    <>
      <Button
        type="primary"
        size="large"
        disabled={isDisabled}
        onClick={() => addToCart(item)}
        icon={<Icon name="cart" size="small" style={{ marginRight: 10 }} />}
      >
        {isMob ? t('labels.to_cart') : t('labels.add_to_cart')}
      </Button>
      <Button
        type="secondary"
        size="large"
        htmlType="button"
        disabled={isDisabled}
        onClick={() => handleAddAndOrder(item)}
      >
        {t('labels.сhoose_a_pharmacy')}
      </Button>
    </>
  );
};

export default Buttons;
